import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getHostCalendarSchedule = async ({ queries }) => {
  const { data } = await SigliveServiceV2({ method: 'GET', url: `/productivity-host/schedule/calendar?${queries}` });

  return data?.data;
};

export default getHostCalendarSchedule;
